import { BasicPassFragment } from 'drycut-graphql';
import { useMemo } from 'react';
import { twMerge } from 'tailwind-merge';
import { Para } from 'ui-components';

type Props = {
  pass: BasicPassFragment;
};

export default function PercentageOff({ pass }: Props) {
  const { specialPromotion, basePrice, price, maxUses } = pass;

  const percentBonus = useMemo(() => {
    const basePerCut = basePrice / maxUses;
    const sparePerCut = (basePrice - price) / maxUses;

    return Math.round((sparePerCut / basePerCut) * 100);
  }, [basePrice, maxUses, price]);

  const baseClasses =
    'transition px-3 py-0.5 absolute -translate-y-1/2 left-1/2 transform -translate-x-1/2 m-auto text-zinc-50 group-hover:text-white';

  const classes = twMerge(
    baseClasses,
    specialPromotion
      ? 'bg-gray-800 group-hover:bg-gray-500'
      : 'bg-primary-600 group-hover:bg-primary-500',
  );

  return (
    <div className={classes}>
      <Para size="sm">Spare {percentBonus}% pro Cut</Para>
    </div>
  );
}
